/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { DeleteSystemCategoryComponent } from './delete-system-category.component';
export { DeleteSystemCategoryModule } from './delete-system-category.module';